module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "append-npower-target-form"
  }, [_c('div', {
    staticClass: "append-npower-target-form__form"
  }, [_c('div', {
    staticClass: "append-target-form__header-menu center"
  }, [(_vm.title) ? [_c('svg-icon', {
    staticClass: "append-npower-target-form__svg",
    attrs: {
      "icon": _vm.svg,
      "width": 60,
      "height": 60
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-h4 font-weight-medium pt-2"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])] : _vm._e()], 2), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "append-npower-target-form__loading"
  }, [_c('loading-dots')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "append-npower-target-form__segments"
  }, [_c('h4', {
    staticClass: "center"
  }, [_vm._v("Target: " + _vm._s(_vm.target.display_name))]), _vm._v(" "), _c('table', {
    staticClass: "append-npower-target-form__table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.segments), function(s) {
    return _c('tr', [_c('td', [_c('span', [_vm._v(_vm._s(s.QuarterName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(s.NetworkName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(s.NumberOfRecords.toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(Math.floor(s.AverageUEs / 1000).toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(new Date(s.UploadedDateTime).toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(s.username))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "append-npower-target-form__upload"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('v-file-input', {
    ref: "fileUploadInput",
    attrs: {
      "accept": _vm.acceptedFileFormat,
      "placeholder": "No file chosen",
      "prepend-icon": "mdi-microsoft-excel"
    },
    on: {
      "change": _vm.onFileChange
    },
    model: {
      value: (_vm.uploadedFile),
      callback: function($$v) {
        _vm.uploadedFile = $$v
      },
      expression: "uploadedFile"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.buttonClickable,
      "color": "success",
      "id": "appendFileModalUploadBtn",
      "label": "upload file"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadFile.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.newSegmentData) ? _c('select-segment-modal', {
    attrs: {
      "fileUploaded": _vm.fileLastUploaded,
      "onCompleteSegmentUpload": _vm.onClose,
      "segmentData": _vm.newSegmentData,
      "currentSegments": _vm.segments,
      "uploadedTargetId": _vm.target.id,
      "uploadedTargetViewingStream": _vm.target.viewing_stream
    }
  }) : (_vm.isLoadingNewSegments) ? _c('div', {
    staticClass: "center"
  }, [_c('loading-dots')], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('span', [_vm._v("Quarter")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Network")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Half-Hour Records")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Average UE (000)")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Uploaded")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Last Modified By")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dd0ed4f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/forms/AppendNPowerForm.vue
// module id = 2392
// module chunks = 0